module.exports = __webpack_public_path__ + "img/11.952a6e21.jpg";